module.exports = __webpack_public_path__ + "img/change-of-auditor.44bdc0c4.svg";